var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCustomizationsTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89355 29.8647C8.34127 29.8647 7.89355 29.417 7.89355 28.8647V27.5918C7.89355 26.1128 8.64215 24.9198 10.1394 24.0127C11.6366 23.1057 13.5897 22.6522 15.9987 22.6522C18.4331 22.6522 20.393 23.1057 21.8782 24.0127C23.3635 24.9198 24.1061 26.1128 24.1061 27.5918V28.8647C24.1061 29.417 23.6584 29.8647 23.1061 29.8647H8.89355ZM16.0024 21.6602C14.8611 21.6602 13.8909 21.2607 13.092 20.4617C12.293 19.6628 11.8936 18.6926 11.8936 17.5513C11.8936 16.3913 12.293 15.4174 13.092 14.6295C13.8909 13.8416 14.8611 13.4476 16.0024 13.4476C17.1624 13.4476 18.1363 13.8416 18.9242 14.6295C19.7121 15.4174 20.1061 16.3913 20.1061 17.5513C20.1061 18.6926 19.7121 19.6628 18.9242 20.4617C18.1363 21.2607 17.1624 21.6602 16.0024 21.6602Z",
    fill: "#0B98A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22C38 11 23.0002 -5.126e-05 16.0002 9.99995C9.00011 -5.98431e-05 -6.12043 11 7.49996 22",
    stroke: "#0B98A9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCustomizationsTeal);
export default __webpack_public_path__ + "static/media/InfoCustomizations-Teal.1825fff4fc824713c55d4db5c6f644e7.svg";
export { ForwardRef as ReactComponent };